import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import { GlobalContext } from 'store/context/GlobalContext';
import useGa from 'hooks/useGa';

export default function Award() {
    const gaTracking = useGa();
    const context = useContext(GlobalContext);
    const { pageTime } = context;

    return (<>
        <div className="inner-bg"></div>
        <div className="inner-page award-page">
            <div className="inner-container">
                <div className="title-box">
                    <div className="title"></div>
                </div>
                <div className="mgt-6 mgb-8 pdx-3 fw-bold">
                    {
                        pageTime.winning ? (<>
                            <div>恭喜以下幸運得主獲得「胡同燒肉」豪華和牛宴！</div>
                            <div className="winner mgt-3">得獎人：{pageTime.winner ? pageTime.winner : ''}</div>
                        </>) : (<>
                            <div>十六茶與「可爾必思」熱烈激戰中！</div>
                            <div className="d-flex justify-content-center flex-wrap">
                                <div className="mgt-3">將於 2022/09/20 於本頁公布</div>
                                <div className="mgt-3">「胡同燒肉豪華和牛宴」得獎人。</div>
                            </div>
                        </>)
                    }
                </div>
                <div>
                    <Link to="/" className="common-btn yellow" onClick={() => gaTracking("award-back-index")}>回活動首頁</Link>
                </div>
            </div>
        </div>
    </>)
}